import React from "react";

function Offers() {
  return (
    <div>
      <h2 className="text-3xl text-center uppercase py-20">Comming Soon...</h2>
    </div>
  );
}

export default Offers;
